//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent, computed, toRefs } from "@vue/composition-api";
import NotificationPopover from "@Shared/components/general/notification-popover";
import PasswordInput from "@Shared/components/inputs/password-input.vue";
import { useI18n } from "vue-i18n-composable";
import { useVuelidate } from "@Shared/@Composables/validations/useVuelidate";
import { validPassword } from "@Shared/@Utils/validation-rules";
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
export default defineComponent({
  name: "RulesPasswordInput",
  components: {
    NotificationPopover,
    PasswordInput
  },
  mixins: [validationMixin],
  validations() {
    return {
      localPassword: {
        required,
        validPassword
      }
    };
  },
  props: {
    password: {
      type: String,
      required: true
    },
    onType: {
      type: Boolean,
      default: true
    }
  },
  setup(props, {
    emit
  }) {
    const {
      password
    } = toRefs(props);
    const {
      t
    } = useI18n();
    const {
      v$
    } = useVuelidate();
    const rules = computed(() => {
      return [{
        rule: t("account.registration.passwordRules.charactersLimit"),
        validate: localPassword.value.match(/^.{12,24}$/)
      }, {
        rule: t("account.registration.passwordRules.atLeastOneUppercase"),
        validate: localPassword.value.match(/.*[A-Z]/)
      }, {
        rule: t("account.registration.passwordRules.atLeastOneLowercase"),
        validate: localPassword.value.match(/.*[a-z]/)
      }, {
        rule: t("account.registration.passwordRules.atLeastOneNumber"),
        validate: localPassword.value.match(/.*[0-9]/)
      }, {
        rule: t("account.registration.passwordRules.atLeastOneSymbol"),
        validate: localPassword.value.match(/.*[!@#$&*+]/)
      }];
    });
    const showPasswordError = computed(() => {
      var _v$$value, _v$$value$localPasswo, _v$$value2, _v$$value2$localPassw;
      return ((_v$$value = v$.value) == null ? void 0 : (_v$$value$localPasswo = _v$$value.localPassword) == null ? void 0 : _v$$value$localPasswo.$invalid) && ((_v$$value2 = v$.value) == null ? void 0 : (_v$$value2$localPassw = _v$$value2.localPassword) == null ? void 0 : _v$$value2$localPassw.$dirty);
    });
    const localPassword = computed({
      get: () => password.value,
      set: val => {
        emit("update:password", val);
      }
    });
    const handlePasswordBlur = () => {
      if (!localPassword.value) v$.value.localPassword.$reset();
    };
    const isMobile = computed(() => {
      return window.innerWidth <= 760;
    });
    return {
      localPassword,
      rules,
      showPasswordError,
      handlePasswordBlur,
      isMobile,
      v$
    };
  }
});